// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2406b9fc] .el-dialog__body{overflow:auto!important}.left-div[data-v-2406b9fc]{max-height:230px}", ""]);
// Exports
module.exports = exports;
